<template>
  <Modal v-model="modal" :title="safe.DetailAddress?$t('title.w31'):$t('title.w32')" :mask-closable="false">
    <div>
      <Form label-position="top" :model="form" ref="form" :rules="formRule">
        <FormItem :label="$t('label.w26')" prop="detailAddress">
          <Input :placeholder="$t('pl.p24')" v-model="form.detailAddress"/>
        </FormItem>
      </Form>
    </div>
    <template slot="footer">
      <Button type="primary" :disabled="form.detailAddress==''" :loading="btnLoading" @click="submit">{{$t('btn.b5')}}</Button>
    </template>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      form: {
        detailAddress: ""
      },
      formRule: {
        detailAddress: [
          { required: true, message: this.$t('msg.m44'), trigger: "submit" }
        ]
      },
      modal: false,
      btnLoading: false
    };
  },
  methods: {
    async submit() {
      // 提交前验证表单
      this.btnLoading = true
      let valid = await this.$refs.form.validate();
      if (!valid) return;
      let res = await this.$axios.post("/Member/RZJProfile/UpdateDetailAddress", this.form);
      this.btnLoading = false
      if (res.err) return res.throw();
      this.$Message.success(this.safe.DetailAddress?this.$t('msg.m40'):this.$t('msg.m45'));
      this.$store.dispatch("user/getSafe");
      this.modal = false;
    }
  },
  computed: {
    safe() {
      return this.$store.state.user.safe;
    }
  },
  watch: {
    modal(v) {
      if(!v) return;
      this.form.detailAddress = this.safe.DetailAddress;
    }
  }
};
</script>
